//import _ from 'lodash';
import { connect } from 'react-redux';
import { getCurrent } from '../../modules/accounting/dataDump';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getCurrentDataDump : getCurrent,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
